<script setup lang="ts"></script>

<template>
  <div></div>
</template>

<style lang="scss" scoped></style>
